// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LiveRegion-module__Container__eKIA1 {
    position: absolute;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
}

.LiveRegion-module__Visible__PCqJt {
    width: 100%;
}

.LiveRegion-module__Visible__PCqJt:empty {
    /* Out of the flow while empty, so it adds no gap to a flex parent */
    position: absolute;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `LiveRegion-module__Container__eKIA1`,
	"Visible": `LiveRegion-module__Visible__PCqJt`
};
export default ___CSS_LOADER_EXPORT___;
